import { Node, NodePos, mergeAttributes } from '@tiptap/react';

export const QuoteCaption = Node.create({
  name: 'quoteCaption',

  group: 'block',

  content: 'text*',

  defining: true,

  isolating: true,

  marks: '',

  parseHTML() {
    return [
      {
        tag: 'cite',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'cite',
      mergeAttributes(HTMLAttributes, { class: `node-${this.name}` }),
      0,
    ];
  },

  addKeyboardShortcuts() {
    return {
      // On Enter at the end of line, create new paragraph and focus
      Enter: ({ editor }) => {
        const {
          state: {
            selection: { $from, empty },
          },
        } = editor;

        if (!empty || $from.parent.type !== this.type) {
          return false;
        }

        const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;

        if (!isAtEnd) {
          return false;
        }

        const pos = editor.state.selection.$from.end();

        return editor
          .chain()
          .focus(pos)
          .insertContentAt(pos, { type: 'paragraph' })
          .run();
      },

      Backspace: ({ editor }) => {
        const {
          state: {
            selection: { $from },
          },
        } = editor;

        if ($from.parent.type.name !== 'quoteCaption') {
          return false;
        }

        const myNodePos = new NodePos($from, editor);
        const xingQuotePos = myNodePos.closest('xingQuote');
        const quoteNodePos = xingQuotePos?.firstChild;

        const quoteCaptionText = $from.node()?.textContent || '';

        if (!quoteCaptionText) {
          const quoteText = quoteNodePos?.textContent || '';

          return editor
            .chain()
            .focus((quoteNodePos?.pos ?? 1) + quoteText.length)
            .run();
        }

        return false;
      },
    };
  },
});

export default QuoteCaption;
